import { Pipe, PipeTransform } from '@angular/core';

import find from 'lodash-es/find';
import get from 'lodash-es/get';

@Pipe({
  name: 'appFind',
})
export class FindPipe implements PipeTransform {
  transform<T>(
    items: T[] | readonly T[] = [],
    path: string[] | string,
    itemToMatch: any,
  ): T {
    return find(items, (item) => itemToMatch === get(item, path));
  }
}
